import StyledInput from "./Input";

export default StyledInput;